export const MessageEngineEvents = {
  Messages: 'Messages',
  LastMessage: 'LastMessage',
  UnreadCount: 'UnreadCount',
  UnreadMark: 'UnreadMark'
} as const

export type MessageEngineEvent = typeof MessageEngineEvents[keyof typeof MessageEngineEvents]
